import authAxios from '@/common/agent/ApiAgent';
import { Profile, SupportLanguage, OnboardingStatus } from '../model/AuthTypes';
import { PlatformType } from '@/main/model/PlatformType';
import Role from '@/auth/signin/model/Role';
import { normalizeLoginId } from '@/common/util/formatUtil';

export type ProfileResponseData = {
  user_id: number;
  username: string;
  brand_name?: string;
  login_id: string;
  photo_uri: string;
  role: Role;
  department_id: string;
  department_name?: string;
  parent_dept_cd?: string;
  language: string;
  test_callback_number: string;
  onboarding_status: string;
  mall_id: string | null;
  platform_type: string;
  subscription: {
    id: number;
    name: string;
    end_date: string; // ex) '2024-08-26'
  } | null;
};

const convertToProfile = (data: ProfileResponseData): Profile => {
  return {
    id: data.user_id,
    name: data.username,
    brandName: data.brand_name,
    loginId: normalizeLoginId(data.login_id),
    photoUri: data.photo_uri,
    role: data.role,
    department: {
      id: data.department_id,
      name: data.department_name || '',
    },
    language: data.language as SupportLanguage,
    testPhone: data.test_callback_number,
    mall_id: data.mall_id,
    platform_type: data.platform_type as PlatformType,
    onboarding_status: data.onboarding_status as OnboardingStatus,
    subscription: data.subscription,
  };
};

const getMe = (): Promise<Profile | null> =>
  authAxios
    .get<ProfileResponseData>('/users/me')
    .then((resp) => convertToProfile(resp.data))
    .catch((error) => {
      if (process.env.NODE_ENV === 'development') {
        console.error('Failed to get me', error);
        return null;
      } else {
        throw error;
      }
    });

export type UpdatableProfileResponseData = Pick<ProfileResponseData, 'username' | 'language' | 'test_callback_number'>;
export type PartOfUpdatableProfileResponseData = Partial<UpdatableProfileResponseData>;
export const putMe = async (id: number, data: PartOfUpdatableProfileResponseData) =>
  await authAxios
    .put<{ result: string }>('/users/me', {
      user_id: id,
      ...data,
    })
    .then((resp) => resp.data);

export default {
  getMe,
  putMe,
};
